import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const MScInAccountingAndFinance = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'50px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 MSc in Accounting and Finance</h1>
      <h2 style={{ textAlign: 'center' }}>Admas University – Ethiopia</h2>
      <p>
        The MSc in Accounting and Finance program at Admas University is designed to equip students with advanced knowledge and practical skills needed to solve real-world financial problems in both public and private sectors. The curriculum is aligned with Ethiopia’s national development priorities, the local financial system, and international standards.
      </p>

      <h3>🎓 Program Objectives</h3>
      <ul>
        <li>To produce highly competent financial analysts and accountants.</li>
        <li>To strengthen decision-making and problem-solving skills in finance and accounting.</li>
        <li>To contribute to the growing need for qualified professionals in Ethiopia’s emerging financial and capital markets.</li>
      </ul>

      <h3>📚 Course Structure</h3>
      <h4>🧩 Year 1 – Semester I</h4>
      <ul>
        <li>Advanced Financial Accounting (IFRS & Local GAAP)</li>
        <li>Managerial Economics with Ethiopian Case Studies</li>
        <li>Quantitative Techniques for Finance</li>
        <li>Corporate Financial Management</li>
      </ul>

      <h4>🧩 Year 1 – Semester II</h4>
      <ul>
        <li>Cost and Management Accounting</li>
        <li>Public Financial Management (PFM) in Ethiopia</li>
        <li>Financial Markets and Institutions in Ethiopia</li>
        <li>Research Methods in Accounting and Finance</li>
      </ul>

      <h4>🧩 Year 2 – Semester I</h4>
      <ul>
        <li>International Accounting Standards (IFRS & IPSAS)</li>
        <li>Investment and Portfolio Management</li>
        <li>Taxation and Fiscal Policy in Ethiopia</li>
        <li>Business Ethics and Corporate Governance</li>
      </ul>

      <h4>🧩 Year 2 – Semester II</h4>
      <ul>
        <li>Elective Courses (Choose One):</li>
        <ul>
          <li>Forensic Accounting & Fraud Prevention</li>
          <li>Finance for NGOs and Development Projects</li>
          <li>Islamic Finance & Alternative Financing</li>
        </ul>
        <li>Thesis/Graduate Research Project: Focused on a relevant Ethiopian financial, public, or private sector issue.</li>
      </ul>

      <h3>🏛️ Why Choose Admas University?</h3>
      <ul>
        <li>Accredited and Recognized by MoE and HERQA</li>
        <li>Expert faculty with academic and industry experience</li>
        <li>Flexible scheduling for working professionals</li>
        <li>Relevant curriculum based on Ethiopian economic trends</li>
      </ul>

      <h3>🧭 Career Opportunities</h3>
      <ul>
        <li>Senior Accountants & Finance Managers</li>
        <li>Public Financial Management Officers</li>
        <li>Investment & Risk Analysts</li>
        <li>Auditors and Tax Experts</li>
        <li>Lecturers and Consultants</li>
      </ul>
    </div>
  );
};

export default MScInAccountingAndFinance;